export default __webpack_public_path__ + "static/media/download-list-empty.6603a223.png";